// src/components/Header.js
import { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Button,
  Menu,
  MenuItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import MenuIcon from "@mui/icons-material/Menu";

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "#12174A", padding: "5px 0" }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Left Side: Logo */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
            src={`${process.env.PUBLIC_URL}/images/logo-gopt.png`} // Change this to your logo path
            alt="Logo"
            style={{ height: 40 }}
          />
          {/* <Typography variant="h6" sx={{ ml: 1, fontWeight: "bold", color: "#FFC107" }}>
            GOPT
          </Typography> */}
        </Box>

        {/* Right Side: Icons & Button */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* Large Screen Icons */}
          <IconButton
            color="inherit"
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <SearchIcon />
          </IconButton>
          <IconButton color="inherit">
            <NotificationsNoneIcon />
          </IconButton>
          <Button
            variant="outlined"
            sx={{
              color: "white",
              borderColor: "white",
              borderRadius: "20px",
              display: { xs: "none", md: "flex" }, // Hide on small screens
              alignItems: "center",
              gap: "5px",
              "&:hover": { borderColor: "#FFC107" },
            }}
          >
            <LocalFireDepartmentIcon sx={{ color: "#FFC107" }} />
            Activity
          </Button>

          {/* Profile Icon (Opens Menu in Small Screens) */}
          <IconButton color="inherit" onClick={handleMenuOpen}>
            <AccountCircleIcon />
          </IconButton>

          {/* Small Screen Menu */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            sx={{ display: { xs: "block", md: "none" } }} // Show only on small screens
          >
            <MenuItem onClick={handleMenuClose}>
              <SearchIcon sx={{ mr: 1 }} /> Search
            </MenuItem>
            <MenuItem onClick={handleMenuClose}>
              <LocalFireDepartmentIcon sx={{ mr: 1, color: "#FFC107" }} />{" "}
              Activity
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
